/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import BaseCom from "./BaseCom";
import Icon from "./Icon";
import Insurance from "./Insurance";

export default class InsuranceList extends BaseCom {
    render() {
        return <div className="mb-3">
        {this.props.list?.map((i,idx) => <div key={idx}>
            <Insurance item={i} edit={this.props.edit} />
        </div>)}
        {this.props.edit && <div className="text-center"><button type="button" className="btn btn-primary" onClick={() => this.addToList(this.props.list, {})}><Icon icon="faPlus" /> New Insurance</button></div>}
        </div>;
    }
}